import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import VehicleForm from "./VehicleForm";

//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { vehicleValidationForm } from "../../utils/validationSchemas";

const EditVehicle = (props: any) => {
  const { handleEdit, isLoading, refetch } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    getValues,
    clearErrors,
    setValue,
  } = useForm<any>({
    resolver: yupResolver(vehicleValidationForm),
    defaultValues: async () => {
      let data: any = await refetch();
      return {
        ...data?.data,
      };
    },
  });

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <VehicleForm
        errors={errors}
        getValues={getValues}
        register={register}
        setValue={setValue}
        clearErrors={clearErrors}
      />
    </FormLayout>
  );
};

export default EditVehicle;
